import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Switch, Redirect } from 'react-router'
import { ConnectedRouter } from 'react-router-redux'
import {
    View,
    ActivityIndicator
} from 'react-native'

import { history } from '../../stores/index'

import styles from './styles'

import MainReducer from './reducer'

import { stateGetIn } from '../../lib/index'

import Login from '../login/index'
import Dashboard from '../dashboard/index'
import Listboard from '../listboard/index'

class Main extends Component {
    static NAME = 'Main'

    componentDidMount() {
        this.props.setEnvironment()
        // this.fetchProfileOnTimer()

        this.props.fetchProfile(false)
        this.props.fetchEndpoints()
        this.props.fetchIdentities()
    }

    // fetchProfileOnTimer(){
    //     this.props.setTimeout(() => {
    //         this.fetchProfileOnTimer()
    //     }, CONSTANTS.INTERVAL_CACHING.MS)

    //     this.props.fetchProfile(false)
    // }

    render() {
        const { isLoading, ...props } = this.props

        return (
            <ConnectedRouter history={history}>
                <View style={styles.appContainer}>
                    <Switch>
                        <ProtectedRoute exact path='/'
                            component={(__r) => <Listboard {...{...__r, ...props}} />} />

                        <Route path='/login/:email?/:pin?'
                            component={(__r) => <Login {...{...__r, ...props}} />} />

                        <ProtectedRoute path='/dashboard'
                            component={(__r) => <Dashboard {...{...__r, ...props}} />} />

                        <ProtectedRoute path='/profile'
                            component={(__r) => <Listboard modalType={'profile'} {...{...__r, ...props}} />} />

                        <ProtectedRoute path='/revenue'
                            component={(__r) => <Dashboard modalType={'revenue'} {...{...__r, ...props}} />} />

                        <ProtectedRoute path='/income'
                            component={(__r) => <Dashboard modalType={'income'} {...{...__r, ...props}} />} />

                        <Redirect to='/' />
                    </Switch>

                    {isLoading && <ActivityIndicator size={'large'} color={'#FF009B'}
                        style={styles.loading} />}
                </View>
            </ConnectedRouter>
        )
    }
}

const mapStateToProps = (state) => ({
    isLoading: stateGetIn(state, MainReducer.NAME, ['isLoading'], 'App', false),
    isAuthenicated: stateGetIn(state, MainReducer.NAME, ['isAuthenicated'], 'App', false)
})

const mapDispatchToProps = (dispatch) => ({
    fetchProfile: (refresh = false) => {
        dispatch(MainReducer.fetchProfile(refresh))
    },
    fetchEndpoints: () =>{
        dispatch(MainReducer.fetchEndpoints())
    },
    fetchIdentities: () => {
        dispatch(MainReducer.fetchIdentities())
    },
    setEnvironment: () => {
        dispatch(MainReducer.setEnvironment())
    }
})

const ProtectedRoute = connect(mapStateToProps, null)((props) => {
    return props.isAuthenicated
            ? <Route component={props.component} />
            : <Redirect to='/login' />
})

export default connect(mapStateToProps, mapDispatchToProps)(Main)



// WEBPACK FOOTER //
// ./src/containers/main/index.js